/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateRead.defs.js'
export * as $defs from './updateRead.defs.js'
